import React from 'react';

import { VerificationRequestForReportItemFragment } from 'src/api';
import { TableColumn } from 'src/components/table';
import { useReportItemsFilter } from 'src/hooks/reports';
import { useCurrentUser } from 'src/hooks/user';

import { getVerificationRequestReportTableColumnsPeoPayrollProviderStaff } from '../constants';

import { VerificationRequestsInnerTable } from './VerificationRequestsInnerTable';

export const VerificationRequestsTablePeoPayrollProvider: React.FC = () => {
  const { timezone } = useCurrentUser();
  const { filter } = useReportItemsFilter();

  const columns = React.useMemo<Array<TableColumn<VerificationRequestForReportItemFragment>>>(
    () => getVerificationRequestReportTableColumnsPeoPayrollProviderStaff(timezone),
    [timezone],
  );

  return <VerificationRequestsInnerTable columns={columns} filter={filter} />;
};
